import { IVec3, Vec3 } from "@base/math/Vec3";

export interface ILengthAngle {
  length: number;
  angle: number;
}

export class WallHelper {
  static #calcFirstPrevPoint(p: IVec3): IVec3 {
    return Vec3.from(p.x - 100, p.y, p.z)
  }

  static calcCornersFromLengthAndAngles(las: ILengthAngle[], startPoint: IVec3): IVec3[] {
    const points: IVec3[] = [
      startPoint
    ];
    let prevPoint = WallHelper.#calcFirstPrevPoint(startPoint);
    let point = startPoint;
    for (const la of las) {
      const dir = Vec3.dir(prevPoint, point);
      const newPoint = Vec3.addScaled(point, Vec3.rotateY(dir, la.angle), la.length)
      points.push(newPoint);
      prevPoint = point;
      point = newPoint;
    }
    return points;
  }

  static calcLengthAngles(points: IVec3[]): ILengthAngle[] {
    const lengthAngles: ILengthAngle[] = [];
    for (let i = 0; i < points.length - 1; i++) {
      const length = Vec3.len(points[i], points[i + 1]);

      const p = points[i];
      const angle = WallHelper.calcAngleSigned(i === 0 ? WallHelper.#calcFirstPrevPoint(p) : points[i - 1], p, points[i + 1]) - Math.PI
      lengthAngles.push({ length, angle })
    }
    return lengthAngles;
  }

  static calcAngleSigned(pre: IVec3, current: IVec3, next: IVec3): number {
    const angle = Vec3.calcAngle(pre, current, next);
    const lastDirNormal = Vec3.rotateY(Vec3.dir(pre, current), Math.PI * 0.5);
    const newDir = Vec3.dir(current, next);
    const dot = Vec3.dot(lastDirNormal, newDir);
    if (dot > 0)
      return 2 * Math.PI - angle;
    return angle;
  }
}